import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router'
import { AuthService } from './auth.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(public auth: AuthService, public router: Router) {}
  // eslint-disable-next-line no-unused-vars
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (!this.auth.isAuthorized) {
      this.auth.redirectUrl = state.url
      console.log(this.auth.redirectUrl, state.url)
      this.router.navigate(['login']).then()
      return false
    }
    return true
  }
}
